import { createStore } from "redux";
import Reducers from "LIBRARY/Reducers/Reducers";
import { applyMiddleware } from "redux";
import thunk from "redux-thunk";


const Store = createStore(
    Reducers,
    applyMiddleware(thunk)
    
);

export default Store;